import { PlaceList, PlaceListBookmark } from '@/pages/types';
import { Button } from '@/trailmix/Button';
import { useDisclosure, useToast } from '@chakra-ui/react';
import { router } from '@inertiajs/react';
import { mdiBookmark, mdiBookmarkOutline } from '@mdi/js';
import Icon from '@mdi/react';
import { useAuth } from '@/auth/useAuth';
import { LoginPromptModal } from '@/pages/components/LoginPromptModal';

export function BookmarkListButton({
    list,
    placeListBookmark,
    canBookmarkList,
}: {
    list: PlaceList;
    placeListBookmark: PlaceListBookmark | null;
    canBookmarkList: boolean;
}) {
    const auth = useAuth();
    const toast = useToast();
    const hasBookmarkedList = placeListBookmark !== null;
    const {
        isOpen: isLoginPromptModalOpen,
        onOpen: onLoginPromptModalOpen,
        onClose: onLoginPromptModalClose,
    } = useDisclosure();

    function createBookmark() {
        router.post(
            route('place-list-bookmarks.store'),
            { place_list_id: list.id },
            {
                preserveScroll: true,
                onSuccess: () => {
                    toast({
                        title: 'Bookmark saved',
                        status: 'success',
                        position: 'top',
                        variant: 'left-accent',
                        isClosable: true,
                    });
                },
                onError: errors => {
                    // eslint-disable-next-line no-console
                    console.error(errors);
                },
            }
        );
    }

    function destroyBookmark() {
        router.delete(route('place-list-bookmarks.destroy', [placeListBookmark]), {
            preserveScroll: true,
            onSuccess: () => {
                toast({
                    title: 'Bookmark removed',
                    status: 'success',
                    position: 'top',
                    variant: 'left-accent',
                    isClosable: true,
                });
            },
            onError: errors => {
                // eslint-disable-next-line no-console
                console.error(errors);
            },
        });
    }

    if (!auth.user) {
        return (
            <>
                <Button
                    onClick={onLoginPromptModalOpen}
                    leftIcon={<Icon path={mdiBookmarkOutline} className='size-5' />}
                >
                    Save
                </Button>
                <LoginPromptModal isOpen={isLoginPromptModalOpen} onClose={onLoginPromptModalClose} />
            </>
        );
    }

    if (!canBookmarkList) {
        return null;
    }

    return (
        <Button
            onClick={hasBookmarkedList ? destroyBookmark : createBookmark}
            leftIcon={<Icon path={hasBookmarkedList ? mdiBookmark : mdiBookmarkOutline} className='size-5' />}
        >
            {hasBookmarkedList ? 'Saved' : 'Save'}
        </Button>
    );
}
